import { LoadingPriorisationDto } from 'src/Libs/wallboxes/dto'
import { LoadingPriorisationModel } from 'src/Libs/wallboxes/models'

const loadPrioDtoToModelTransformer = (dto: LoadingPriorisationDto): LoadingPriorisationModel => ({
  tillSoc: dto.tillSoc,
  isBattery: dto.isBattery,
  inMixMode: dto.inMixMode,
  inSunMode: dto.inSunMode,
})
export default loadPrioDtoToModelTransformer
